import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/motion";
import { SERVICES } from "@/data/site";

export default function ServicesPreview() {
  return (
    <section className="bg-white py-28 lg:py-36" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <Chapter index="03" label="What We Do" />
            <Reveal delay={0.1}>
              <h2 className="mt-8 max-w-2xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl">
                Workforce Solutions<br />Designed for <span className="text-gold">Construction</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-charcoal/70">
              Flexible labour hire solutions designed to support the changing workforce requirements of
              construction projects.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06} className="h-full">
              <Link
                to="/services"
                data-testid={`service-card-${i}`}
                className="group flex h-full flex-col border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-navy"
              >
                <span className="grid h-12 w-12 place-items-center bg-gold/10 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                  <s.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-heading text-lg font-bold leading-snug text-navy">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal/70">{s.text}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-navy/40 transition-colors group-hover:text-gold">
                  Learn more
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
